export class DeviceTypes {
    static mobile = 'Mobile';
    static tablet = 'Tablet';
    static computer = 'Computer';
    static largeScreen = 'LargeScreen';
    static widescreen = 'Widescreen';
}